module.exports = __webpack_public_path__ + "Flag-188.90922bd6e1209322cd522b520d409857.svg";